export default __webpack_public_path__ + "static/media/thinking-emoji.2dabc609.svg";